import { useQuery } from '@tanstack/react-query';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { bookingChangePublicMapper } from '@/features/dashboard/bookingChanges/types/BookingChangePublicDto.mapper.ts';
import { PendingChangeVm } from '@/features/dashboard/bookingChanges/types/PublicChangeViewModel.ts';
import {
  PublicClientDto,
  PublicSummaryParticipantDto,
} from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';

/**
 * Paczka czekająca na decyzję klienta — wejście panelu na podsumowaniu
 * rezerwacji. `null`, gdy nic nie czeka, i wtedy panel po prostu nie powstaje.
 *
 * Podsumowanie idzie tu w komplecie, bo kontrakt zmian niesie sam stan docelowy:
 * bez niego byłyby grupy bez nazwisk, a każda pozycja mówiłaby, na co się zmienia,
 * nie mówiąc, z czego.
 */
const useGetPendingPublicChange = (
  orgSlug: string,
  token: string,
  participants: PublicSummaryParticipantDto[],
  client: PublicClientDto,
) =>
  useQuery({
    queryKey: bookingChangesApiQueryKeys.publicChange(orgSlug, token),
    queryFn: () => bookingChangesApi.getPublicChangeByToken(orgSlug, token),
    enabled: !!orgSlug && !!token,
    select: (dto): PendingChangeVm | null =>
      dto
        ? bookingChangePublicMapper.toPendingChangeVm(dto, participants, client)
        : null,
  });

export default useGetPendingPublicChange;
